import {
  fetchSubmission as fetchSubmissionRequest,
  fetchUploadOffset as fetchUploadOffsetRequest,
  fetchUploaderSubmissionPage as fetchUploaderSubmissionPageRequest,
} from '@/features/mcap/api/submissions';
import { redactSubmissionWriteCapability } from '@/features/mcap/lib/submissionCapability';
import type { SubmissionSession, UploaderSubmissionPage } from '@/features/mcap/types/contracts';
import type { ApiCallOptions } from '@/shared/api/client';

export async function fetchSubmission(
  sessionId: string,
  options: ApiCallOptions = {},
): Promise<SubmissionSession> {
  return redactSubmissionWriteCapability(await fetchSubmissionRequest(sessionId, options));
}

export async function fetchUploaderSubmissionPage(
  uploaderId: string,
  params: { cursor?: string } = {},
  options: ApiCallOptions = {},
): Promise<UploaderSubmissionPage> {
  const page = await fetchUploaderSubmissionPageRequest(uploaderId, params, options);
  return {
    ...page,
    items: page.items.map(redactSubmissionWriteCapability),
  };
}

export async function fetchUploadOffset(
  sessionId: string,
  options: ApiCallOptions = {},
): Promise<number> {
  return (await fetchUploadOffsetRequest(sessionId, options)).offset;
}
